import { css } from '~/lib/bn-lit-element';

export const sessionStyles = css`
  :host {
    display: block;
    overflow: hidden;
  }

  .boxes {
    padding: 20px;
  }

  .box {
    background-color: var(--surface, white);
    max-width: 300px;
    margin: 0 auto;
    padding: 20px;
    border: 1px solid #ddd;
    display: flex;
    flex-direction: column;
  }

  bn-logo {
    margin-bottom: 1em;
  }

  .form-actions button {
    width: 100%;
  }

  .form-item input {
    width: 100%;
  }

  a {
    font-size: 1.15em;
    color: var(--blue-50);
  }

  a:hover {
    cursor: pointer;
  }
`;

export default sessionStyles;
